/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import { SaveDealAsIgnore200ResponseCardTransactionEvidenceListInner } from './save-deal-as-ignore200-response-card-transaction-evidence-list-inner';
// May contain unused imports in some cases
// @ts-ignore
import { SaveDealAsIgnore200ResponseIntegratedBy } from './save-deal-as-ignore200-response-integrated-by';
// May contain unused imports in some cases
// @ts-ignore
import { SaveDealAsIgnore200ResponseInvoiceIssuer } from './save-deal-as-ignore200-response-invoice-issuer';
// May contain unused imports in some cases
// @ts-ignore
import { SaveDealAsIgnore200ResponseJournalEntriesInner } from './save-deal-as-ignore200-response-journal-entries-inner';
// May contain unused imports in some cases
// @ts-ignore
import { SaveDealAsIgnore200ResponseJournalizedBy } from './save-deal-as-ignore200-response-journalized-by';

/**
 * 
 * @export
 * @interface SaveDealAsIgnore200Response
 */
export interface SaveDealAsIgnore200Response {
    /**
     * 
     * @type {string}
     * @memberof SaveDealAsIgnore200Response
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof SaveDealAsIgnore200Response
     */
    'issuedAt': string;
    /**
     * 
     * @type {string}
     * @memberof SaveDealAsIgnore200Response
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof SaveDealAsIgnore200Response
     */
    'freeeDealId': string | null;
    /**
     * 
     * @type {string}
     * @memberof SaveDealAsIgnore200Response
     */
    'freeePartnerId': string | null;
    /**
     * 
     * @type {number}
     * @memberof SaveDealAsIgnore200Response
     */
    'partnerId': number | null;
    /**
     * 
     * @type {number}
     * @memberof SaveDealAsIgnore200Response
     */
    'amountYen': number;
    /**
     * 
     * @type {string}
     * @memberof SaveDealAsIgnore200Response
     */
    'visaTransactionReferenceId': string | null;
    /**
     * 
     * @type {string}
     * @memberof SaveDealAsIgnore200Response
     */
    'status': SaveDealAsIgnore200ResponseStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof SaveDealAsIgnore200Response
     */
    'cardHolder': string | null;
    /**
     * 
     * @type {SaveDealAsIgnore200ResponseJournalizedBy}
     * @memberof SaveDealAsIgnore200Response
     */
    'journalizedBy': SaveDealAsIgnore200ResponseJournalizedBy | null;
    /**
     * 
     * @type {string}
     * @memberof SaveDealAsIgnore200Response
     */
    'journalizedAt': string | null;
    /**
     * 
     * @type {SaveDealAsIgnore200ResponseIntegratedBy}
     * @memberof SaveDealAsIgnore200Response
     */
    'integratedBy': SaveDealAsIgnore200ResponseIntegratedBy | null;
    /**
     * 
     * @type {string}
     * @memberof SaveDealAsIgnore200Response
     */
    'integratedAt': string | null;
    /**
     * 
     * @type {string}
     * @memberof SaveDealAsIgnore200Response
     */
    'userAccountId': string | null;
    /**
     * 
     * @type {string}
     * @memberof SaveDealAsIgnore200Response
     */
    'userAccountName': string | null;
    /**
     * 
     * @type {string}
     * @memberof SaveDealAsIgnore200Response
     */
    'userAccountGroupId': string | null;
    /**
     * 
     * @type {string}
     * @memberof SaveDealAsIgnore200Response
     */
    'userAccountGroupName': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof SaveDealAsIgnore200Response
     */
    'isOnDemand': boolean | null;
    /**
     * 
     * @type {Array<SaveDealAsIgnore200ResponseJournalEntriesInner>}
     * @memberof SaveDealAsIgnore200Response
     */
    'journalEntries': Array<SaveDealAsIgnore200ResponseJournalEntriesInner>;
    /**
     * 
     * @type {Array<SaveDealAsIgnore200ResponseCardTransactionEvidenceListInner>}
     * @memberof SaveDealAsIgnore200Response
     */
    'cardTransactionEvidenceList': Array<SaveDealAsIgnore200ResponseCardTransactionEvidenceListInner>;
    /**
     * true if the deal has one or more evidences and those all are not qualified, which should be shown as a warning to users.
     * @type {boolean}
     * @memberof SaveDealAsIgnore200Response
     */
    'isAllEvidencesNotQualified': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SaveDealAsIgnore200Response
     */
    'canSync': boolean;
    /**
     * 
     * @type {SaveDealAsIgnore200ResponseInvoiceIssuer}
     * @memberof SaveDealAsIgnore200Response
     */
    'invoiceIssuer': SaveDealAsIgnore200ResponseInvoiceIssuer | null;
}

export const SaveDealAsIgnore200ResponseStatusEnum = {
    notEntered: 'NOT_ENTERED',
    automaticJournalized: 'AUTOMATIC_JOURNALIZED',
    automaticIntegrated: 'AUTOMATIC_INTEGRATED',
    entering: 'ENTERING',
    journalized: 'JOURNALIZED',
    changedAfterJournalization: 'CHANGED_AFTER_JOURNALIZATION',
    integrated: 'INTEGRATED',
    changedAfterIntegration: 'CHANGED_AFTER_INTEGRATION',
    ignored: 'IGNORED',
    readyAutomaticIntegration: 'READY_AUTOMATIC_INTEGRATION'
} as const;

export type SaveDealAsIgnore200ResponseStatusEnum = typeof SaveDealAsIgnore200ResponseStatusEnum[keyof typeof SaveDealAsIgnore200ResponseStatusEnum];


